export const commonOptions = {
  hpeDataOpsManager: 'HPE Data Ops Manager',
  blockStorage: 'Block Storage',
  hostIntegration: 'Host Integration',
  localGatewayConnectivity: 'Local gateway connectivity',
  networking: 'Networking',
  performance: 'Performance',
  setupService: 'Setup Service',
  dashboard: 'Dashboard',
  other: 'Other',
};

export const helpWithOptions = {
  backupAndRecovery: 'Backup and Recovery',
  blockStorage: commonOptions.blockStorage,
  dataObservability: 'Data Observability',
  disasterRecovery: 'Disaster Recovery',
  fileStorage: 'File Storage',
  objectService: 'Object Service',
  cloudPhysics: 'HPE CloudPhysics',
  privateCloudAI: 'Private Cloud AI',
  privateCloudBusiness: 'Private Cloud Business Edition',
  storageFabric: 'Storage Fabric Management',
};

export const backupAndRecoveryOptions = {
  snapshot: 'Snapshot',
  replication: 'Replication',
  copy: 'Copy',
  recovery: 'Recovery',
  restore: 'Restore',
  applicationRegistration: 'Application registration',
  softwareDownload: 'Software download',
  setupAndInstalation: 'Setup and installation',
  // localGatewayConnectivity: universalOptions.localGatewayConnectivity,
  other: commonOptions.other,
};

export const primaryBlockStorageOptions = {
  dashboard: commonOptions.dashboard,
  alletra5000: 'HPE Alletra Storage 5000',
  alletra6000: 'HPE Alletra Storage 6000',
  alletra9000: 'HPE Alletra Storage 9000',
  alletraStorage: 'HPE Alletra Storage MP',
  blockStorageAWS: 'HPE GreenLake Block Storage for AWS',
  nimbleStorage: 'HPE Nimble Storage',
  primeraStorage: 'HPE Primera Storage'
}

export const objectServiceOptions = {
  dashboard: commonOptions.dashboard,
  alletraX100000: 'HPE Alletra Storage MP X10000 issue',
  other: commonOptions.other,
}

export const fileStorageOptions = {
  dashboard: commonOptions.dashboard,
  alletraStorageMP: 'HPE Alletra Storage MP issue',
  other: commonOptions.other,
};

export const privateCloudBusinessOptions = {
  dhci: 'dHCI',
  alletraStorageBlock: 'HPE Alletra Storage MP for Block',
  simpliVity: 'SimpliVity',
}
export const storageFabricOptions = {
  dashboard: commonOptions.dashboard,
  deviceOrHardware: 'Device or Hardware Issue',
}

export const disasterRecoveryOptions = {
  dashboard: commonOptions.dashboard,
  technicalIssue: 'Technical issue',
  caseManagement: 'Case Management Issue / Training Access',
};

export const cloudPhysicsOptions = {
  loginAccountSupport: 'HPE CloudPhysics Login /Account Management',
  partnerCustomerInvitations: 'Partner/Customer Invitations',
  applianceSupport: 'Appliance support',
  portal: 'HPE CloudPhysics Portal',
  other: commonOptions.other,
};

export const dataObservabilityOptions = {
  dashboard: commonOptions.dashboard,
  data: 'Data',
  other: commonOptions.other,
}
export const protectionOptions = [
  'Yes',
  'No',
  'Unknown',
];

export const severityOptions = {
  critical: '1-Critical',
  major: '2-Major',
  medium: '3-Medium',
};

export const timeZoneOptions: string[] = [
  'Americas (9 a.m.-6 p.m., Eastern USA)',
  'APJ (7 a.m.-3 p.m., GMT+8)',
  'EMEA (7 a.m.-4 p.m., GMT)',
];
